<template>
  <kendo-window ref="kendoWindowRef"
                :title="'메뉴마스터목록'"
                :modal="true"
                :width="'982px'"
                style="z-index: 10004; transform: scale(1); opacity: 1; display:none;"
                @close="onCloseKendoWindow">
    <div class="pwindow">
      <h1>솔루션 : {{solNm}}</h1>
      <div class="k-window-content k-content">
        <div class="k-desc">
          <ul class="k-sea">
            <li class="w70">
              <kendo-dropdownlist
                ref="wmGbnRef"
                id="wmGbn"
                :data-source="$store.state.codeRequestStore.search.combobox.wmGbn.data"
                :data-text-field="'cdNm'"
                :data-value-field="'cdId'"
                :option-label="'솔루션구분 선택'"
                :style="'width: 100%;'"
                @change="onClickSearch"
              >
              </kendo-dropdownlist>
            </li>
          </ul>
        </div>
        <div class="k-desc">
          <ul class="k-sea">
            <li class="w20">
              <kendo-dropdownlist
                ref="searchCdRef"
                id="searchCd"
                :data-source="searchTextData"
                :data-text-field="'cdNm'"
                :data-value-field="'cdNameSpace'"
                :style="'width: 100%;'"
              >
              </kendo-dropdownlist>
            </li>
            <li class="w50">
              <kendo-maskedtextbox
                ref="searchTextRef"
                id="searchText"
                :style="'width: 100%;'"
                :placeholder="'검색어를 입력하세요.'"
              >
              </kendo-maskedtextbox>
            </li>
            <li class="w20">
              <button class="mid_btn orange" @click="onClickSearch"><span class="k-icon k-i-zoom"></span> 검색 </button>
            </li>
          </ul>
        </div>
        <!-- Kendo Treelist 영역 -->
        <kendo-treelist ref="menuMasterListWindowTreeListRef"
                        id="menuMasterListWindowTreeList"
                        :height="301"
                        :data-source="treeListDataSource"
                        :columns="treeListColumns"
                        :dataBound="onDataBoundTreeList"
        >
        </kendo-treelist>
        <!-- Kendo 영역 끝 -->
        <div class="button_wrap_area">
          <ul>
            <li>
              <button class="large_btn orange" @click="onClickSet">확인 </button>
            </li>
            <li>
              <button class="large_btn" @click="onClickClose">취소</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </kendo-window>
</template>

<script>
  import $ from 'jquery'
  import ApiUtil from '@/api/api.util'
  import ApiConfig from '@/api/api.config'
  import EtnersCommonUtil from '@/common/etners.common.util'
  import EtnersParseUtil from '@/common/etners.parse.util'
  import EtnersKendoGridUtil from '@/common/kendo.grid.util'

  export default {
    name: 'MenuMasterListWindow',
    props: [ 'solCd', 'solNm', 'exceptMenuIdListProps' ],
    mounted: function() {
      const vm = this

      // 검색어 enter 처리
      let element = document.getElementById('searchText')
      if(element !== undefined) {
        element.onkeyup = function(e) {
          const ENTER_KEY_CODE = 13

          let currentKeyCode = window.event.keyCode || e.which
          if(currentKeyCode === ENTER_KEY_CODE) {
            vm.onClickSearch(e)
          }
        }
      }
    },
    methods: {
      getMenuList: function(param) {

        const vm = this
        return new Promise(resolve => {

          ApiUtil.post(`${ApiConfig.platformDomain}/v1/ebmp/admin/auth/menuList.json`, param)
          .then(response => {

            if (response.data === undefined || response.data.resultStatus === undefined) {
              kendo.alert('데이터가 정상적으로 조회되지 않았습니다.')
              return false
            }
            if (response.data.resultStatus.messageCode !== '2000') {
              kendo.alert(response.data.resultStatus.messageText)
              return false
            }


            // 공통코드 처리
            let commonCodeMap = EtnersCommonUtil.getAllCommonCodeMapUsingVuex()

            if(commonCodeMap !== undefined) {
              let changeResultData = response.data.resultData

              for (let i = 0; i < changeResultData.length; i++) {
                let row = changeResultData[i]

                row.wmGbn = EtnersParseUtil.convertCodeGrupFormat('102', row.wmGbn)
                // converting code to text (웹/모바일구분)
                row.cvtWmGbn = EtnersParseUtil.commonCodeToText(commonCodeMap, row.wmGbn)
              }

              response.data.resultData = changeResultData
            }

            let menuListResponse = response.data.resultData

            resolve(menuListResponse)
          })
          .catch(error => {
            console.log(error)
          })
        })
      },

      /**
       * Kendo Treelist 관련 이벤트
       */
      setCheckedParent: function(wmGbn, targetMenuId, checkedFlag) {
        /* Kendo Treelist에서 대상 부모 checkbox 활성화 */

        let targetRowData = this.treeListDataSource.filter(data => {
          return data.wmGbn === wmGbn && data.menuId === targetMenuId
        })

        targetRowData = targetRowData[0]

        let targetWmGbn = targetRowData.wmGbn
        let targetCheckboxId = 'chk_'+targetWmGbn+'_'+targetMenuId

        document.getElementById(targetCheckboxId).checked = checkedFlag
      },
      setCheckedChild: function(wmGbn, targetSuperMenuId, checkedFlag) {
        /* Kendo Treelist에서 대상 자식 checkbox 활성화 */

        let targetRowDataList = this.treeListDataSource.filter(data => {
          return data.wmGbn === wmGbn && data.superMenuId === targetSuperMenuId
        })

        targetRowDataList.forEach(targetRowData => {
          let targetWmGbn = targetRowData.wmGbn
          let targetMenuId = targetRowData.menuId
          let targetCheckboxId = 'chk_'+targetWmGbn+'_'+targetMenuId

          document.getElementById(targetCheckboxId).checked = checkedFlag
        })
      },
      onDataBoundTreeList: function(e) {
        /* Kendo Treelist dataBound 이벤트 */

        const vm = this

        let grid = e.sender
        let items = e.sender.items()

        items.each(function () {
          let dataItem = grid.dataItem(this)
          let checkbox = $('.k-checkbox', this)

          // Treelist row의 checkbox 클릭 이벤트
          $(checkbox).click(function(ev) {
            const checkbox = this
            let checked = checkbox.checked
            const id = dataItem.menuId
            const parentId = dataItem.superMenuId
            const wmGbn = dataItem.wmGbn

            if(checked === true) {
              if(parentId !== null) {
                // 체크활성된 메뉴가 하위메뉴면 부모메뉴 체크 활성화 처리
                vm.setCheckedParent(wmGbn, parentId, true)
              } else {
                // 체크활성된 메뉴가 부모메뉴면 하위메뉴 체크 활성화 처리
                vm.setCheckedChild(wmGbn, id, true)
              }

            } else {
              if(parentId !== null) {
                // 체크비활성된 메뉴가 하위메뉴면 부모메뉴 체크 비활성화 처리(같은 하위메뉴들 checked 여부 확인하여)
                vm.setCheckedParent(wmGbn, parentId, false)
              } else {
                // 체크비활성된 메뉴가 부모메뉴면 하위메뉴 체크 비활성화 처리
                vm.setCheckedChild(wmGbn, id, false)
              }
            }

          })
        })

        // Treelist header의 checkbox 클릭 이벤트
        let checkboxAll = $('#chk_all', e.sender.thead)
        checkboxAll.click(function(ev) {
          const checkbox = this
          let checkedFlag = checkbox.checked

          let checkboxes = document.getElementsByClassName('k-checkbox')
          for(let i=0; i<checkboxes.length; i++) {
            checkboxes[i].checked = checkedFlag
          }
        })

        //sample
        /*let treeList = this.$refs.menuMasterListWindowTreeListRef.kendoWidget()
        let view = treeList.dataSource.view()
        treeList.items().each(function(index, row) {
          kendo.bind(row, view[index])
        })*/
      },
      /*onChangeTreeList: function(e) {
        let selectedRow = e.sender.select()
        let rowData = e.sender.dataItem(selectedRow)
        console.log("parentId:::"+rowData.parentId)
      },*/

      /**
       * 버튼 관련 이벤트
       */
      onClickSearch: function (e) {
        /* 검색 버튼 클릭 이벤트 */

        const vm = this

        let wmGbn = vm.$refs.wmGbnRef.kendoWidget().value()
        let searchCd = vm.$refs.searchCdRef.kendoWidget().value()
        let searchText = vm.$refs.searchTextRef.kendoWidget().value()

        let searchFilterOptions = new Array()
        if(wmGbn !== undefined && wmGbn !== '') {
          searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({ columnName: 'wmGbn', value: wmGbn }))
        }
        if(searchCd !== undefined && searchCd !== '') {
          searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({ columnName: searchCd, value: searchText }))
        }
        searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({ columnName: 'useYn', value: 'Y' }))

        // 부모화면에서 전달받은 검색 제외할 {웹/모바일구분, 메뉴ID}
        let exceptMenuList = []
        if(vm.$props.exceptMenuIdListProps !== undefined && vm.$props.exceptMenuIdListProps !== null) {
          exceptMenuList = vm.$props.exceptMenuIdListProps
        }

        /*let param = {
          loginUserToken: sessionStorage.lutk,
          skip          : 0,
          take          : 10,
          page          : 1,
          pageSize      : 10,
          filter        : searchFilterOptions,
          requestType   : 'EXPORT', // PAGING or EXPORT
        }*/
        let param = {
          loginUserToken: sessionStorage.lutk,
          solCd: vm.$props.solCd,
          wmGbn: wmGbn,
          menuId: (searchCd === 'menuId' ? searchText : ''),
          menuNm: (searchCd === 'menuNm' ? searchText : ''),
          exceptMenuList: exceptMenuList
        }
        vm.getMenuList(param).then(function(response) {

          response.forEach(result => {
            result.id = result.menuId
            result.parentId = result.superMenuId
            result.checkboxId = 'chk_'+result.wmGbn+'_'+result.menuId
          })

          vm.treeListDataSource = response
        })
      },
      onClickSet: function (e) {
        /* 확인 버튼 클릭 이벤트 */

        const vm = this

        let checkboxes = document.getElementsByClassName('k-checkbox')
        let checkboxIds = []
        for(let i=0; i<checkboxes.length; i++) {
          if(checkboxes[i].checked === true) {
            let checkboxId = checkboxes[i].id
            checkboxIds.push(checkboxId)
          }
        }

        let checkedRowDataList = []
        vm.treeListDataSource.forEach(dataSource => {
          if(checkboxIds.indexOf(dataSource.checkboxId) > -1) {
            checkedRowDataList.push(dataSource)
          }
        })

        // 부모화면에 선택한 row data list 전달
        vm.$parent.callbackFromMenuMasterListWindow(checkedRowDataList)
        vm.onClickClose(e);

      },
      onCloseKendoWindow: function (e) {
        /* window on close 이벤트 */

        // 검색영역 초기화
        this.$refs.wmGbnRef.kendoWidget().select(0)
        this.$refs.searchCdRef.kendoWidget().select(0)
        this.$refs.searchTextRef.kendoWidget().value("")
        // 그리드 dataSource 초기화
        this.treeListDataSource = []

      },
      onClickClose: function(e) {
        /* 취소 버튼 클릭 이벤트 */
        // window 닫기
        this.$refs.kendoWindowRef.kendoWidget().close()
      },

      //test
      /*toggleAll: function(e) {
        let treeList = this.$refs.menuMasterListWindowTreeListRef.kendoWidget()
        let view = treeList.dataSource.view()
        let checked = e.target.checked

        for(let i=0; i<view.length; i++) {
          view[i].set("checked", checked)
        }
      },*/
    },
    data: function () {
      const vm = this

      return {
        searchTextData: [
          { cdNm: "메뉴명", cdNameSpace: "menuNm" },
          { cdNm: "메뉴ID", cdNameSpace: "menuId" }
        ],
        treeListColumns: [
          {
            headerTemplate: "<input class='k-checkbox' data-role='checkbox' type='checkbox' id='chk_all' /><label for='chk_all' class='k-checkbox-label k-no-text'></label>",
            template: function(dataItem) {
              return "<input class='k-checkbox' data-role='checkbox' type='checkbox' id='"+dataItem.checkboxId+"' /><label for='"+dataItem.checkboxId+"' class='k-checkbox-label k-no-text chk_label'></label>"
            },
            width: '10%'
          },
          { expandable: true, width: '5%' },
          { field: "menuId", title: '메뉴ID',  width: '30%' },
          { field: "menuNm", title: '메뉴명', width: '30%' },
          { field: "cvtWmGbn", title: '웹/모바일구분', width: '25%' }
        ],
        treeListDataSource: [],
      }
    }
  }
</script>

<style scoped>
</style>
